module.exports = __webpack_public_path__ + "2ea63ed43a35f15c6abfa866d06ba9aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/pineapple.png
// module id = 2417
// module chunks = 0